export enum Probezeit {
  KEINE = 'Keine Probezeit',
  HALBJAHR = '6 Monate',
}
